import { Component, OnInit } from '@angular/core';
import { ISpecificBrickSettingsComponent } from 'src/app/components/dashboard/brick-settings/brick-specific-type-settings/ISpecificBrickSettingsComponent';
import { Observable } from 'rxjs';
import { WebViewerSettingState } from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/webviewer/webviewer-settings.state';
import { Store } from '@ngxs/store';
import {
   ChangeAllowAttributes,
   ChangeTagDrivenURL,
   ChangeUseSkillURL,
} from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/webviewer/webviewer-settings.actions';
import { map } from 'rxjs/operators';

@Component({
   selector: 'samweb-webviewer-brick-settings',
   templateUrl: './webviewer-brick-settings.component.html',
   styleUrls: ['./webviewer-brick-settings.component.scss'],
})
export class WebviewerBrickSettingsComponent implements OnInit, ISpecificBrickSettingsComponent {
   public brickInstanceId: string;
   public tagDrivenURL$: Observable<string>;
   public allowAttributes$: Observable<string>;
   public useSkillURL$: Observable<boolean>;
   constructor(private store: Store) {}

   ngOnInit(): void {
      this.tagDrivenURL$ = this.store.select(WebViewerSettingState.getTagDrivenURLSetting).pipe(map((fn) => fn(this.brickInstanceId)));
      this.allowAttributes$ = this.store.select(WebViewerSettingState.getAllowAttributes).pipe(map((fn) => fn(this.brickInstanceId)));
      this.useSkillURL$ = this.store.select(WebViewerSettingState.getUseSkillURL).pipe(map((fn) => fn(this.brickInstanceId)));
   }

   changeSkillUrl(value: boolean) {
      this.store.dispatch(new ChangeUseSkillURL(this.brickInstanceId, value));
   }

   tagDrivenUrlTextChanged(value: string) {
      this.store.dispatch(new ChangeTagDrivenURL(this.brickInstanceId, value));
   }

   allowAttributesTextChanged(value: string) {
      this.store.dispatch(new ChangeAllowAttributes(this.brickInstanceId, value));
   }
}
